import React from 'react';
import { Empty } from 'antd';
import { EmptyStateContainer } from '../../styled';
import BookingsList from "../../BookingsList";
import TablePagination from '../TablePagination';
import usePagination from '../../usePagination';

const BookingsSection = ({ 
  bookings, 
  refreshBookings,
  emptyMessage = "No bookings to display"
}) => {
  const {
    paginatedData,
    currentPage,
    pageSize,
    total,
    handlePageChange,
    handlePageSizeChange
  } = usePagination(bookings);

  return (
    <>
      {bookings.length > 0 ? (
        <>
          <BookingsList
            bookings={paginatedData}
            refreshBookings={refreshBookings}
          />
          
          <TablePagination
            current={currentPage}
            pageSize={pageSize}
            total={total}
            onChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </>
      ) : (
        <EmptyStateContainer>
          <Empty description={emptyMessage} />
        </EmptyStateContainer>
      )}
    </>
  );
};

export default BookingsSection;